<div class="fm-rs-steps">

  <!-- Page Title -->
  <div class="fm-page-title">
    <h1 class="fm-head-24 fm-title">Create a New Memory</h1>
  </div>

  <!-- Step Header -->
  <div class="fm-rs-step-form">
    <div class="fm-step-wrapper">
      <div class="fm-white-column">
        <div class="fm-step-list">
          <div class="fm-step-item" [class.active]="currentStep() >= 1" [class.completed]="currentStep() > 1"
               (click)="currentStep() > 1 && goToStep(1)" role="button" tabindex="0" aria-label="Step 1: Choose Category">
            <div class="fm-step-icon"><img class="fm-svg" src="images/icons/fm-step1-icon.svg" alt="" /></div>
            <div class="fm-step-number">Step 01</div>
            <div class="fm-step-title">Choose Category</div>
          </div>
          <div class="fm-step-item" [class.active]="currentStep() >= 2" [class.completed]="currentStep() > 2"
               (click)="currentStep() > 2 && goToStep(2)" role="button" tabindex="0" aria-label="Step 2: Select Media Type">
            <div class="fm-step-icon"><img class="fm-svg" src="images/icons/fm-step2-icon.svg" alt="" /></div>
            <div class="fm-step-number">Step 02</div>
            <div class="fm-step-title">Select Media Type</div>
          </div>
          <div class="fm-step-item" [class.active]="currentStep() >= 3" [class.completed]="currentStep() > 3"
               (click)="currentStep() > 3 && goToStep(3)" role="button" tabindex="0" aria-label="Step 3: Select Questions">
            <div class="fm-step-icon"><img class="fm-svg" src="images/icons/fm-step3-icon.svg" alt="" /></div>
            <div class="fm-step-number">Step 03</div>
            <div class="fm-step-title">Select Questions</div>
          </div>
          <div class="fm-step-item" [class.active]="currentStep() >= 4" role="button" tabindex="0" aria-label="Step 4: Record & Publish">
            <div class="fm-step-icon"><img class="fm-svg" src="images/icons/fm-step4-icon.svg" alt="" /></div>
            <div class="fm-step-number">Step 04</div>
            <div class="fm-step-title">Record &amp; Publish</div>
          </div>
        </div>
      </div>
    </div>

    <!-- ================================================================== -->
    <!-- STEP 1: Choose Category                                              -->
    <!-- ================================================================== -->
    @if (currentStep() === 1) {
      <div class="fm-step-content active">
        <div class="fm-card-wrapper">
          <div class="fm-white-column">
            <div class="fm-section-title">
              <h2 class="fm-head-24">What Kind Of Memory Would You Like To Share?</h2>
              <p>Choose a category to get started with AI-powered prompts</p>
            </div>

            @if (loadingCategories()) {
              <div class="fm-loading-state">
                <div class="spinner-border text-secondary" role="status">
                  <span class="visually-hidden">Loading categoriesâ€¦</span>
                </div>
                <p>Loading categoriesâ€¦</p>
              </div>
            } @else {
              <div class="fm-category-grid">
                @for (cat of categories(); track cat.categoryId) {
                  <div class="fm-category-box">
                    <input type="radio" name="memory" [id]="'cat-' + cat.categoryId"
                           [checked]="selectedCategoryId() === cat.categoryId"
                           (change)="selectCategory(cat.categoryId)" />
                    <label class="fm-category-label" [for]="'cat-' + cat.categoryId">
                      <div class="fm-check-icon">
                        <img src="images/icons/fm-check.svg" class="fm-svg" alt="Selected" />
                      </div>
                      <div class="fm-category-icon">
                        <img [src]="cat.iconUrl || 'images/icons/memory-share-icons/fm-ms-icon1.svg'" class="fm-svg" [alt]="cat.categoryName" />
                      </div>
                      <h4 class="fm-head-22">{{ cat.categoryName }}</h4>
                      <p>{{ cat.totalPrompt }} prompts available</p>
                    </label>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="fm-form-footer">
          <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn" (click)="cancelRecord()">
            Cancel
          </button>
          <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt"
                  [disabled]="!selectedCategoryId() || loadingCategories()"
                  (click)="onStep1Continue()">
            Continue
            <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="" />
          </button>
        </div>
      </div>
    }

    <!-- ================================================================== -->
    <!-- STEP 2: Select Media Type                                            -->
    <!-- ================================================================== -->
    @if (currentStep() === 2) {
      <div class="fm-step-content active">
        <div class="fm-card-wrapper">
          <div class="fm-white-column">
            <div class="fm-compressed-cl">
              <div class="fm-section-title">
                <h2 class="fm-head-24">How Would You Like To Tell Your Story?</h2>
                <p>Choose the best way to capture your memories</p>
              </div>
              <div class="fm-media-list">
                @for (media of mediaTypeOptions; track media.id) {
                  <div class="fm-media-card" [class.active]="selectedMediaType() === media.id"
                       (click)="selectMediaType(media.id)" role="button" tabindex="0"
                       [attr.aria-pressed]="selectedMediaType() === media.id">
                    <div class="fm-media-left">
                      <div class="fm-media-icon">
                        <img [src]="media.icon" class="fm-svg" [alt]="media.label" />
                      </div>
                      <div>
                        <h4 class="fm-head-22">{{ media.label }}</h4>
                        <p>{{ media.description }}</p>
                      </div>
                    </div>
                    <div class="fm-check-icon">
                      <img src="images/icons/fm-check.svg" class="fm-svg" alt="Selected" />
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="fm-compressed-cl">
          <div class="fm-form-footer fm-space-between">
            <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn" (click)="prevStep()">
              <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="" /> Back
            </button>
            <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt" (click)="nextStep()">
              Continue <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="" />
            </button>
          </div>
        </div>
      </div>
    }

    <!-- ================================================================== -->
    <!-- STEP 3: Select Questions                                             -->
    <!-- ================================================================== -->
    @if (currentStep() === 3) {
      <div class="fm-step-content active">
        <div class="fm-card-wrapper">
          <div class="fm-white-column">
            <div class="fm-compressed-cl fm-large-cl">
              <div class="fm-section-title">
                <h2 class="fm-head-24">Select Questions</h2>
                <p>Choose which prompts you want to answer in your story</p>
              </div>

              @if (loadingPrompts()) {
                <div class="fm-loading-state">
                  <div class="spinner-border text-secondary" role="status">
                    <span class="visually-hidden">Loading promptsâ€¦</span>
                  </div>
                </div>
              } @else {
                <div class="fm-question-list">
                  @for (q of prompts(); track q.key; let i = $index) {
                    <div class="fm-question-card" [class.active]="q.selected">
                      <span class="fm-question-number">{{ (i + 1).toString().padStart(2, '0') }}</span>

                      @if (q.editing) {
                        <!-- Inline edit mode (custom questions only) -->
                        <div class="fm-question-edit-row">
                          <input type="text" class="form-control fm-question-edit-input"
                                 [value]="q.editDraft"
                                 (input)="updateEditDraft(q.key, $any($event.target).value)" />
                          <button type="button" class="btn fm-icon-btn fm-icon-btn-sm"
                                  (click)="saveEdit(q)" aria-label="Save edit">
                            <img src="images/icons/fm-bookmark.svg" class="fm-svg" alt="Save" />
                          </button>
                          <button type="button" class="btn fm-icon-btn fm-icon-btn-sm"
                                  (click)="cancelEdit(q.key)" aria-label="Cancel edit">
                            <img src="images/icons/fm-close.svg" class="fm-svg" alt="Cancel" />
                          </button>
                        </div>
                      } @else {
                        <p class="mb-0 fm-question-text">{{ q.questionText }}</p>
                        <div class="fm-question-actions">
                          @if (q.source === 'Custom') {
                            <button type="button" class="fm-question-menu-btn"
                                    (click)="startEdit(q.key)" aria-label="Edit question">
                              <img src="images/icons/fm-edit.svg" class="fm-svg" alt="Edit" />
                            </button>
                            <button type="button" class="fm-question-menu-btn"
                                    (click)="deleteCustomQuestion(q)" aria-label="Delete question">
                              <img src="images/icons/fm-delete.svg" class="fm-svg" alt="Delete" />
                            </button>
                          }
                        </div>
                      }

                      <div class="fm-check-icon" (click)="togglePrompt(q.key)" role="button" tabindex="0"
                           [attr.aria-label]="(q.selected ? 'Deselect' : 'Select') + ' question'">
                        <img src="images/icons/fm-check-white.svg" class="fm-svg" alt="" />
                      </div>
                    </div>
                  }
                </div>

                <!-- Add custom question -->
                @if (!addingQuestion()) {
                  <div class="fm-add-question-btn">
                    <button type="button" class="fm-common-btn" (click)="addingQuestion.set(true)">
                      <img src="images/icons/fm-plus-large.svg" class="fm-svg" alt="" />
                      Add Your Own Question
                    </button>
                  </div>
                }
                @if (addingQuestion()) {
                  <div class="fm-custom-question">
                    <div class="form-group">
                      <input type="text" class="form-control" placeholder="Type your questionâ€¦"
                             [value]="newQuestionDraft()"
                             (input)="newQuestionDraft.set($any($event.target).value)" />
                      <button type="button" class="btn fm-icon-btn" (click)="saveNewQuestion()"
                              [disabled]="savingQuestion() || !newQuestionDraft().trim()" aria-label="Save question">
                        @if (savingQuestion()) {
                          <span class="spinner-border spinner-border-sm"></span>
                        } @else {
                          <img src="images/icons/fm-bookmark.svg" class="fm-svg" alt="Save" />
                        }
                      </button>
                      <button type="button" class="btn fm-icon-btn"
                              (click)="addingQuestion.set(false); newQuestionDraft.set('')" aria-label="Cancel">
                        <img src="images/icons/fm-trash.svg" class="fm-svg" alt="Cancel" />
                      </button>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        </div>

        <div class="fm-compressed-cl fm-large-cl">
          <div class="fm-form-footer fm-space-between">
            <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn" (click)="prevStep()">
              <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="" /> Back
            </button>
            <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt"
                    (click)="nextStep()">
              Continue <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="" />
            </button>
          </div>
        </div>
      </div>
    }

    <!-- ================================================================== -->
    <!-- STEP 4-A: Record / Upload                                            -->
    <!-- ================================================================== -->
    @if (currentStep() === 4 && step4Phase() === 'record') {
      <div class="fm-step-content active">

        <!-- VIDEO RECORDING -->
        @if (selectedMediaType() === 1) {
          <div class="fm-card-wrapper">
            <div class="row g-4">
              <div class="col-lg-8">
                <div class="fm-recording-wrapper">

                  <!-- Progress -->
                  @if (selectedPrompts().length > 0) {
                    <div class="fm-progress-wrapper">
                      <p class="fm-que-txt">{{ selectedPrompts().length }} Question{{ selectedPrompts().length !== 1 ? 's' : '' }}</p>
                      <p class="fm-pcompleted-count">{{ recordingState() === 'done' ? '100' : (recordingState() === 'idle' ? '0' : '50') }}% Completed</p>
                    </div>
                    <div class="progress fm-progress-bar mb-3">
                      <div class="progress-bar" [style.width]="(recordingState() === 'done' ? 100 : recordingState() === 'idle' ? 0 : 50) + '%'"></div>
                    </div>
                  }

                  <div class="fm-video-box">

                    <!-- IDLE -->
                    @if (recordingState() === 'idle') {
                      <div class="fm-video-preview">
                        <div class="fm-video-icon">
                          <img src="images/icons/fm-video-lg.svg" class="fm-svg" alt="Video" />
                        </div>
                      </div>
                      <div class="fm-video-btn">
                        <div class="row g-3 g-xl-4">
                          <div class="col-sm-6">
                            <button type="button" class="fm-common-btn fm-record-btn fm-large-btn w-100"
                                    (click)="startCameraAndRecord()">
                              <img src="images/icons/fm-record.svg" class="fm-svg" alt="" />
                              Record Video
                            </button>
                          </div>
                          <div class="col-sm-6">
                            <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn fm-upload-btn fm-large-btn w-100"
                                    (click)="triggerFileUpload()">
                              <img src="images/icons/fm-upload.svg" class="fm-svg" alt="" />
                              Upload Video
                            </button>
                          </div>
                        </div>
                      </div>
                    }

                    <!-- REQUESTING -->
                    @if (recordingState() === 'requesting') {
                      <div class="fm-video-preview">
                        <div class="fm-video-icon">
                          <span class="spinner-border text-secondary" role="status"></span>
                        </div>
                        <p class="mb-0 mt-2 text-muted">Requesting camera access&hellip;</p>
                      </div>
                    }

                    <!-- RECORDING -->
                    @if (recordingState() === 'recording') {
                      <div class="fm-video-preview fm-is-recording" style="padding:0;overflow:hidden;min-height:unset;background:#000;">
                        <video #webcamVideo class="w-100 d-block" style="max-height:360px;object-fit:cover;" autoplay muted playsinline></video>
                        <span class="fm-rec-badge">
                          <span class="fm-rec-dot"></span>
                          REC {{ formatSeconds(recordingSeconds()) }}
                        </span>
                      </div>
                      <div class="fm-video-btn">
                        <div class="row g-3 g-xl-4">
                          <div class="col-sm-6">
                            <button type="button" class="fm-common-btn fm-record-btn fm-large-btn w-100"
                                    (click)="stopRecording()">
                              <img src="images/icons/fm-stop.svg" class="fm-svg" alt="" />
                              Stop Recording
                            </button>
                          </div>
                        </div>
                      </div>
                    }

                    <!-- DONE -->
                    @if (recordingState() === 'done') {
                      <div class="fm-video-preview" style="padding:0;overflow:hidden;min-height:unset;background:#000;">
                        <video #previewVideo class="w-100 d-block" style="max-height:360px;border-radius:10px;"
                               [src]="previewUrl()" controls playsinline></video>
                      </div>

                      @if (isUploading()) {
                        <div class="fm-upload-status fm-upload-progress mt-2">
                          <span class="spinner-border spinner-border-sm me-2"></span>
                          Uploading to cloud&hellip;
                        </div>
                      } @else if (uploadedFileName()) {
                        <div class="fm-upload-status fm-upload-done mt-2">
                          <img src="images/icons/fm-check-sm.svg" class="fm-svg me-1" alt="" />
                          Upload complete
                        </div>
                      }

                      @if (videoDuration() > 0) {
                        <div class="fm-golden-column fm-trim-cl mt-3">
                          <div class="row align-items-center">
                            <div class="col">
                              <h3 class="fm-heading-sm">
                                <img src="images/icons/fm-sizzer-cl.svg" alt="" /> Trim Video
                              </h3>
                            </div>
                            <div class="col-auto">
                              <h3 class="fm-heading-sm" role="button" style="cursor:pointer"
                                  (click)="trimStart.set(0); trimEnd.set(videoDuration())">
                                <img src="images/icons/fm-reset.svg" alt="" /> Reset
                              </h3>
                            </div>
                            <div class="col-12">
                              <p class="fm-small mt-1">Drag the sliders to set the start and end points.</p>
                            </div>
                          </div>
                          <div class="fm-trim-row mt-2">
                            <label class="fm-trim-label">Start</label>
                            <input type="range" class="form-range fm-trim-range"
                                   [min]="0" [max]="videoDuration() - 1" [step]="1"
                                   [value]="trimStart()"
                                   (input)="onTrimStartChange(+$any($event.target).value)" />
                            <span class="fm-trim-time">{{ formatSeconds(trimStart()) }}</span>
                          </div>
                          <div class="fm-trim-row">
                            <label class="fm-trim-label">End</label>
                            <input type="range" class="form-range fm-trim-range"
                                   [min]="1" [max]="videoDuration()" [step]="1"
                                   [value]="trimEnd()"
                                   (input)="onTrimEndChange(+$any($event.target).value)" />
                            <span class="fm-trim-time">{{ formatSeconds(trimEnd()) }}</span>
                          </div>
                          <div class="row g-3 align-items-center mt-1">
                            <div class="col-sm">
                              <p class="fm-duretion-txt mb-0">New duration: <span class="fw-semibold">{{ formatSeconds(trimEnd() - trimStart()) }}</span></p>
                            </div>
                          </div>
                        </div>
                      }

                      <div class="fm-video-btn">
                        <div class="row g-3 g-xl-4">
                          <div class="col-sm-6">
                            <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn fm-large-btn w-100"
                                    (click)="retakeVideo()">
                              <img src="images/icons/fm-refresh.svg" class="fm-svg" alt="" />
                              Retake / Change
                            </button>
                          </div>
                          <div class="col-sm-6">
                            <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt fm-large-btn w-100"
                                    [disabled]="isUploading()"
                                    (click)="onContinueFromRecord()">
                              @if (isUploading()) {
                                <span class="spinner-border spinner-border-sm me-2"></span>Uploading&hellip;
                              } @else {
                                Finish &amp; Review <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="" />
                              }
                            </button>
                          </div>
                        </div>
                      </div>
                    }

                    <input type="file" #videoFileInput class="d-none" accept="video/*" (change)="onVideoFileSelected($event)" />
                  </div>

                  @if (recordingState() !== 'done') {
                    <div class="fm-form-footer fm-space-between">
                      <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn" (click)="prevStep()">
                        <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="" /> Back
                      </button>
                    </div>
                  }

                </div>
              </div>

              <!-- Sidebar -->
              <div class="col-lg-4">
                <div class="row g-4">
                  <div class="col-12 col-sm-6 col-lg-12">
                    <div class="fm-sidebar-card fm-question-list-accordion">
                      <div class="fm-sidebar-title">
                        <button type="button" class="fm-question-list-toggle" data-bs-toggle="collapse"
                                data-bs-target="#fmRecordQuestionsList" aria-expanded="true" aria-controls="fmRecordQuestionsList">
                          <span class="fm-head-20">Questions List</span>
                          <img src="images/icons/fm-down-ar-tin.svg" class="fm-svg fm-ql-acc-arrow" alt="Toggle" />
                        </button>
                      </div>
                      <div class="fm-collapse collapse show" id="fmRecordQuestionsList">
                        <div class="fm-question-list">
                          @for (q of selectedPrompts(); track q.key; let i = $index) {
                            <div class="fm-question-card" [class.active]="recordingState() === 'recording'">
                              <span class="fm-question-number">{{ (i + 1).toString().padStart(2, '0') }}</span>
                              <p class="mb-0 fm-question-text">{{ q.questionText }}</p>
                              <div class="fm-check-icon">
                                <img src="images/icons/fm-check-white.svg" class="fm-svg" alt="" />
                              </div>
                            </div>
                          }
                          @if (!selectedPrompts().length) {
                            <p class="mb-0 text-muted fm-small py-2">No questions selected</p>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-lg-12">
                    <div class="fm-sidebar-card">
                      <div class="fm-sidebar-title"><h5 class="fm-head-20">Recording Tips</h5></div>
                      <hr class="w-100" />
                      <div class="fm-recording-tips-list">
                        <div class="fm-detail-item">
                          <div class="fm-detail-icon"><img class="fm-svg" src="images/icons/fm-speak-sm.svg" alt="" /></div>
                          <div class="fm-detail-content"><p class="fm-detail-text">Speak naturally, as if talking to a friend</p></div>
                        </div>
                        <div class="fm-detail-item">
                          <div class="fm-detail-icon"><img class="fm-svg" src="images/icons/fm-clock-sm.svg" alt="" /></div>
                          <div class="fm-detail-content"><p class="fm-detail-text">Take your time &amp; pause when needed</p></div>
                        </div>
                        <div class="fm-detail-item">
                          <div class="fm-detail-icon"><img class="fm-svg" src="images/icons/fm-check-sm.svg" alt="" /></div>
                          <div class="fm-detail-content"><p class="fm-detail-text">Include specific details and emotions</p></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        }

        <!-- AUDIO RECORDING -->
        @if (selectedMediaType() === 2) {
          <div class="fm-card-wrapper">
            <div class="row g-4">
              <div class="col-lg-8">
                <div class="fm-recording-wrapper">
                  <div class="fm-audio-box">
                    <div class="fm-audio-preview">
                      <div class="fm-audio-icon">
                        <img src="images/icons/fm-micro-icon.svg" class="fm-svg" alt="Microphone" />
                      </div>
                      <div class="fm-audio-waveform mt-3">
                        <img src="images/icons/fm-audio-wave.svg" class="fm-audio-wave-img" alt="Wave" />
                      </div>
                    </div>
                    <div class="fm-audio-btn">
                      <div class="row g-3 g-xl-4">
                        <div class="col-sm-6">
                          <button type="button" class="fm-common-btn fm-record-btn fm-large-btn w-100">
                            <img src="images/icons/fm-record.svg" class="fm-svg" alt="" /> Record Audio
                          </button>
                        </div>
                        <div class="col-sm-6">
                          <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn fm-upload-btn fm-large-btn w-100">
                            <img src="images/icons/fm-upload.svg" class="fm-svg" alt="" /> Upload Audio
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="fm-form-footer fm-space-between">
                    <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn" (click)="prevStep()">
                      <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="" /> Back
                    </button>
                    <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt" (click)="onContinueFromRecord()">
                      Finish &amp; Review <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="" />
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="fm-sidebar-card">
                  <div class="fm-sidebar-title"><h5 class="fm-head-20">Recording Tips</h5></div>
                  <hr class="w-100" />
                  <div class="fm-recording-tips-list">
                    <div class="fm-detail-item">
                      <div class="fm-detail-icon"><img class="fm-svg" src="images/icons/fm-speak-sm.svg" alt="" /></div>
                      <div class="fm-detail-content"><p class="fm-detail-text">Speak naturally, as if talking to a friend</p></div>
                    </div>
                    <div class="fm-detail-item">
                      <div class="fm-detail-icon"><img class="fm-svg" src="images/icons/fm-clock-sm.svg" alt="" /></div>
                      <div class="fm-detail-content"><p class="fm-detail-text">Take your time &amp; pause when needed</p></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        <!-- IMAGE + AUDIO -->
        @if (selectedMediaType() === 3) {
          <div class="fm-card-wrapper">
            <div class="row g-4">
              <div class="col-lg-8">
                <div class="fm-recording-wrapper">
                  <div class="fm-audio-box">
                    <div class="fm-audio-preview">
                      <label for="fmImageInput" class="fm-audio-icon fm-audio-upload-label" style="cursor:pointer">
                        <img src="images/icons/fm-upload.svg" class="fm-svg" alt="Upload Photo" />
                      </label>
                      <p class="mb-0">Drop your photo here or <span class="fm-browse-link">Browse</span></p>
                      <input type="file" id="fmImageInput" class="d-none" accept="image/*" />
                      <div class="fm-audio-waveform mt-3">
                        <img src="images/icons/fm-audio-wave.svg" class="fm-audio-wave-img" alt="Wave" />
                      </div>
                    </div>
                    <div class="fm-audio-btn">
                      <div class="row g-3 g-xl-4">
                        <div class="col-sm-6">
                          <button type="button" class="fm-common-btn fm-record-btn fm-large-btn w-100">
                            <img src="images/icons/fm-record.svg" class="fm-svg" alt="" /> Record Audio
                          </button>
                        </div>
                        <div class="col-sm-6">
                          <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn fm-upload-btn fm-large-btn w-100">
                            <img src="images/icons/fm-upload.svg" class="fm-svg" alt="" /> Upload Audio
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="fm-form-footer fm-space-between">
                    <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn" (click)="prevStep()">
                      <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="" /> Back
                    </button>
                    <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt" (click)="onContinueFromRecord()">
                      Finish &amp; Review <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="" />
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="fm-sidebar-card">
                  <div class="fm-sidebar-title"><h5 class="fm-head-20">Recording Tips</h5></div>
                  <hr class="w-100" />
                  <div class="fm-recording-tips-list">
                    <div class="fm-detail-item">
                      <div class="fm-detail-icon"><img class="fm-svg" src="images/icons/fm-speak-sm.svg" alt="" /></div>
                      <div class="fm-detail-content"><p class="fm-detail-text">Speak naturally, as if talking to a friend</p></div>
                    </div>
                    <div class="fm-detail-item">
                      <div class="fm-detail-icon"><img class="fm-svg" src="images/icons/fm-clock-sm.svg" alt="" /></div>
                      <div class="fm-detail-content"><p class="fm-detail-text">Take your time &amp; pause when needed</p></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

      </div>
    }

